/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { B2BApprovalProcess, Currency } from '@lm-nx-frontend/lm-inf-core';

declare module '@lm-nx-frontend/lm-inf-core' {
  interface B2BUnit {
    parentOrgUnit?: Partial<B2BUnit>;
    approvalProcess?: B2BApprovalProcess;
    administrators?: B2BUser[];
    approvers?: B2BUser[];
    customers?: B2BUser[];
    costCenters?: CostCenter[];
    managers?: B2BUser[];
  }

  interface B2BUser {
    approvers?: [];
    orgUnit?: B2BUnit;
    selected?: boolean;
    isAssignedToApprovers?: boolean;
    email?: string;
  }

  interface CostCenter {
    activeFlag?: boolean;
    currency?: Currency;
    originalCode?: string;
  }
}
